import React from 'react';
import AppLayout from '../components/AppLayout';
import u from '../utilities/Utilities';
import {LoadGraphic} from '../components/Common';
import {TaskGroup} from './TaskList';
import '../styles/single-page.scss';

export default class TaskGroupPage extends React.Component{
    r={};

    state={
        error:"",
        entryData:{},
        options:{},
        loading:false,
        loadText:"",
        step:1,
        combinedPerms:{},
    };

    settings={
        /**** Page Setup ****/
        title:"Worksite Groups",
        permission:"combined",     //Accepts combined permission module as well
        combinedField:"taskGroup", //Used when permission exists in a combined field
        url:"/check-in",
        label:"check-in",
    };

    componentDidMount=()=>{
        this.setState({combinedPerms:u.getPermissions("combined")});
    }

    getOptions=()=>{
      u.post({
        url:"/api/get-options",
        data:{
            keys:[],
        },
        success:(options)=>{
            this.setState({options:options});
        },
        error:(error)=>{
            this.setState({error:error});
        }
      })
    }

    onChange=(value,field,index)=>{
        let {entryData}=this.state;
        entryData[field]=value;
        this.setState({entryData:entryData});
    }

    render=()=>{
        const {loading,loadText}=this.state;

        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>
                <div className='single-page-container'>
                    <h2 className='sp-title'>Worksite & Task Groups</h2>
                    <div style={{textAlign:"center",margin:"20px auto"}}>
                        Worksites & task groups are groupings of staff that can be assigned to tasks & feedback entries.<br/>
                        All groups will appear as possible 'General Location' when app users are creating new feedback/safety shoutout entries.
                    </div>
                    
                    <div className='sp-content'>
                        <LoadGraphic active={loading} text={loadText}/>
                        <TaskGroup/>
                    </div>
                </div>                 
            </AppLayout>
        )
    }
}
